import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { clearKxQuoteCache } from './routing'

export function useClearKxQuoteCache() {
  const queryClient = useQueryClient()

  return useCallback(() => clearKxQuoteCache(queryClient), [queryClient])
}
